var anchors = document.getElementsByTagName('a');

for (var i=0; i<anchors.length; i++){
    var href = anchors[i].getAttribute("href")
    if (href && href.startsWith('http') ){
        console.log(anchors[i])
        anchors[i].setAttribute('target', '_blank')
        anchors[i].setAttribute("rel", "noopener")
    }
}